import * as d3 from 'd3';
import {useEffect, useRef, useState} from 'react';

import {getStatHistory} from 'src/api/stats';

import {renderGraph} from './utils';

const height = 100;

interface Stats {
    date: Date,
    value: number,
}

const ImpactLineGraphView = ({
  id,
  size,
  definitionId,
  setLoading,
}: {
  id: string,
  size: {width: number | null, height: number | null},
  definitionId: string,
  setLoading: (_: boolean) => void,
}) => {
  const svgRef = useRef(null);
  const [stats, setStats] = useState<Array<Stats>>([]);

  useEffect(() => {
    const loadData = async () => {
      if (!id) {
        return;
      }
      const priorDate = new Date();
      priorDate.setDate(new Date().getDate() - 90);
      const isoDate = priorDate.toISOString().substring(0, 10);

      setLoading(true);
      const response = await getStatHistory(id, 'impactScore', isoDate, definitionId);
      setLoading(false);

      const stats: Array<Stats> = response.data?.map((es) => {
        return {
          date: d3.timeParse('%Y-%m-%d')(es.timestamp.substring(0, 10)),
          value: parseFloat(es.value) * 100,
        } as Stats;
      }) || [];

      setStats(stats);
    };
    loadData();
  }, [id]);

  useEffect(() => {
    if (svgRef.current) {
      renderGraph(stats, svgRef.current, size);
    }
  }, [stats, size, svgRef]);

  return stats ? (
      <svg ref={svgRef} width={size.width ?? undefined} height={height} textAnchor='middle'></svg>
    ) : null;
};

export default ImpactLineGraphView;
